import ONBOARDING_PAPER_CLASS_NAME from '../../constants/paper';

const MuiPaper = {
  styleOverrides: {
    root: () => ({
      [`&.${ONBOARDING_PAPER_CLASS_NAME}`]: {
        backgroundColor: 'white',
        boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.12)',
        borderRadius: 20,
      },
    }),
  },
};

export default MuiPaper;
